export default __webpack_public_path__ + "static/media/itunes-brands.560f876c.svg";